/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Web3 from "web3";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./css/App.scss";

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Modal from "./components/Modal";

import Main from "./Pages/Main";
import Vender from "./Pages/Vender";
import Comprar from "./Pages/Comprar";
import Aboutus from "./Pages/Aboutus";
import Contact from "./Pages/Contact";
import Marketplace from "./Pages/Marketplace";
import NftDetail from "./Pages/NftDetail";
import Faqs from "./Pages/Faqs";
import Contacto from "./Pages/Contacto";

function App() {
  const [openSidebar, setOpenSidebar] = useState(false);
  return (
    <div className="App">
      <BrowserRouter>
        <Sidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
        <Header openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
        <Routes>
          <Route path="/" element={<Main />} exact />
          <Route path="/vender" element={<Vender />} exact />
          <Route path="/comprar" element={<Comprar />} exact />
          <Route path="/quienes" element={<Aboutus />} exact />
          <Route path="/contacto" element={<Contact />} exact />
          <Route path="/marketplace" element={<Marketplace />} exact />
          <Route path="/NftDetail" element={<NftDetail />} exact />
          <Route path="/faqs" element={<Faqs />} exact />
          <Route path="/club" element={<Contacto />} exact />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
